import * as types from "./actionTypes";

export function setTemplateProgressType(buttonType) {
	return { type: types.SET_TEMPLATE_PROGRESS_TYPE, buttonType };
}
export function updateTemplateProgressType(progressType) {
	return { type: types.UPDATE_TEMPLATE_PROGRESS_TYPE, progressType };
}
